import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'truncateText',
})
export class TruncateTextPipe implements PipeTransform {
  transform(value: string = '', max = 15, ell = '…'): string {
    return value.length > max ? value.slice(0, max) + ell : value;
  }
}
